var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgShops = function SvgShops(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "currentColor",
    viewBox: "0 0 36 36"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(5 4.75)",
    strokeWidth: 1.5,
    fill: "none",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.474 4.632H23.9a2.314 2.314 0 0 1 2.281 2.7l-1.691 7.932a1.153 1.153 0 0 1-1.135.949H6.369"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.316,
    cy: 2.316,
    r: 2.316,
    transform: "translate(6.948 22.001)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.316,
    cy: 2.316,
    r: 2.316,
    transform: "translate(19.685 22.001)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c2.316 0 2.316 1.158 3.474 4.632l3.474 13.9c.115.534.39 1.158.936 1.158h16.434"
  }))));
};
export default SvgShops;